import { BREAKPOINTS } from "@laerdal/life-react-components";
import { styled } from "styled-components";

const PaligoContent = styled.div`
    display: flex;
    gap: 16px;
    flex-direction: column;

    h1, h2, h3, h4, h5, h6, p, span {
        max-width: unset;
        font-family: Lato;
    }

    p, span{
        color: var(--life-color-text-default);
        font-feature-settings: 'liga' off;
        /* S - Mobile/Paragraph */
        font-family: Lato;
        font-size: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: 150%; /* 24px */
        margin: 0;

        ${BREAKPOINTS.LARGE} {
            color: var(--life-color-text-default);
            font-feature-settings: 'liga' off;
            /* L - Desktop/Paragraph */
            font-family: Lato;
            font-size: 20px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 30px */
        }
    }

    h1, h2, h3, h4, h5, h6 {
        color: var(--life-color-text-default);
        font-feature-settings: 'liga' off;
        /* S - Mobile/H6 */
        font-family: Lato;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%; /* 24px */

        ${BREAKPOINTS.LARGE} {
        color: var(--life-color-text-default);
        font-feature-settings: 'liga' off;
        /* S - Mobile/H6 */
        font-family: Lato;
        font-size: 20px;
        font-style: normal;
        font-weight: 700;
        line-height: 120%; /* 24px */
        }
    }

  
    .informaltable table {
        display: block ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table ;
            width: 100% ;
        }
    }
    .informaltable colgroup {
        display: none ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table-column-group ;
            width: 100% ;
        }
    }
        
        

    .informaltable thead {
        display: block ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table-header-group ;
            width: unset ;
        }
    }

    .informaltable tbody {
        display: block ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table-row-group ;
            width: unset ;
        }
    }

    .informaltable tr {
        display: block ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table-row ;
            width: unset ;
        }
    }

    .informaltable td,
    .informaltable th {
        display: block ;
        width: 100% ;

        ${BREAKPOINTS.LARGE} {
            display: table-cell ;
            width: unset ;
        }
    }

    .caution, .note, .tip {
        img {
            width: 12px;
            height: 12px;
            
            ${BREAKPOINTS.LARGE} {
                width: 15px;
                height: 15px;
            }
        }
        th {
            color: var(--life-color-text-default);
            font-feature-settings: 'liga' off;
            /* S - Mobile/Note */
            font-family: Lato;
            font-size: 12px;
            font-style: normal;
            font-weight: 700;
            line-height: 150%; /* 18px */
            
            ${BREAKPOINTS.LARGE} {
                color: var(--life-color-text-default);
                font-feature-settings: 'liga' off;
                /* L - Desktop/Note */
                font-family: Lato;
                font-size: 15px;
                font-style: normal;
                font-weight: 700;
                line-height: 150%; /* 22.5px */
            }
        }
        td {
            width: unset;
        }

        table tbody > tr:first-child > td:first-child {
            width: 12px;
            
            ${BREAKPOINTS.LARGE} {
                width: 15px;
            }
        }

        p, span, em {
            font-style: italic;
            color: var(--life-color-text-subtle);
            font-feature-settings: 'liga' off;
            /* S - Mobile/Note */
            font-family: Lato;
            font-size: 12px;
            font-style: normal;
            font-weight: 400;
            line-height: 150%; /* 18px */
            
            ${BREAKPOINTS.LARGE} {
                font-feature-settings: 'liga' off;
                /* L - Desktop/Note */
                font-family: Lato;
                font-size: 15px;
                font-style: normal;
                font-weight: 400;
                line-height: 150%; /* 22.5px */
            }
        }
    }

    ul, ol {
        padding-left: 20px;
        margin: 0;
    }

    table {
        width: 100%;
    }

    div.mediaobject {
        margin: 0;
    }

    table td, table th {
        border: 0;
        vertical-align: top;
    }

    .itemizedlist {
        margin: 0;
    }
    .section {
        gap: 8px;
        display: flex;
        flex-direction: column;
    }
`;

export default PaligoContent;
